import React, { useEffect, useState } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import Input from "../../components/input";
import FIlterSelect from "../../components/filter-select";
import {
  capitalizeFirstLetter,
  getStatusColor,
  getStatusTextColor,
} from "../../utilz/function";

interface SupplierData {
  _id: string;
  name: string;
  email: string;
  contactPerson: string;
  phone: number;
  status: string;
}

interface UserTableProps {
  data: SupplierData[];
  selectedStatus?: string;
  handleStatusChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const SupplierTable: React.FC<UserTableProps> = ({ data, selectedStatus }) => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState<SupplierData[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const columns = [
    { header: "Supplier Name", accessor: "name" },
    { header: "Contact Person", accessor: "contact" },
    { header: "Email", accessor: "email" },
    { header: "Phone Number", accessor: "phone" },
    { header: "Status", accessor: "status" },
    { header: "Actions", accessor: "_id" },
  ];

  const handleUserClick = (_id: string) => {
    navigate(`/dashboard/supplier/${_id}`);
  };

  useEffect(() => {
    const filtered = data?.filter((supplier) => {
      const statusMatch =
        !selectedStatus || supplier?.status === selectedStatus;

      const searchMatch =
        !searchQuery ||
        supplier?.contactPerson
          ?.toLowerCase()
          .includes(searchQuery?.toLowerCase()) ||
        supplier.email?.toLowerCase().includes(searchQuery?.toLowerCase());
      const customerMatch = !selectedType || supplier?.status === selectedType;

      return statusMatch && searchMatch && customerMatch;
    });
    setFilteredData(filtered);
  }, [data, selectedStatus, searchQuery, selectedType]);

  const combinedData = filteredData?.map((supplier) => ({
    ...supplier,
    contact: (
      <div>
        <div>{capitalizeFirstLetter(supplier?.contactPerson) || "N/A"}</div>
      </div>
    ),
    name: (
      <div>
        <div>{capitalizeFirstLetter(supplier?.name) || "N/A"}</div>
      </div>
    ),
    status: (
      <div
        // style={{
        //   backgroundColor: getStatusColor(supplier?.status),
        //   color: getStatusTextColor(supplier?.status),
        // }}
        className="rounded-full"
      >
        {capitalizeFirstLetter(supplier.status)}
      </div>
    ),
  }));

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleCustomerFilterChange = (selectedValue: string) => {
    setSelectedType(selectedValue);
  };

  return (
    <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
      <div className="md:flex justify-between px-5">
        <p className="text-[20px] font-bold">Suppliers</p>
        <div className="md:flex gap-2 items-center md:mt-0 mt-2">
          <Input
            name="search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full"
            placeholder="Search"
            icon="searchIcon"
          />

          <FIlterSelect
            name="filter"
            options={[
              { value: "active", label: "Active" },
              { value: "inactive", label: "InActive" },
              { value: "pending", label: "Pending Approval" },
            ]}
            className="mt-2 md:mt-0 w-full md:w-[50%]"
            icon="filterIcon"
            onChange={handleCustomerFilterChange}
            value={selectedType}
          />
        </div>
      </div>

      {combinedData?.length > 0 ? (
        <Table
          columns={columns}
          data={combinedData}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (
        <div className="opacity-80 mt-10 font-bold text-center mx-auto">
          No supplier found
        </div>
      )}
    </div>
  );
};

export default SupplierTable;
